<template>
  <div class="taskManage">
    <el-row>
      <el-col>
        <div class="query">
          <div>
            任务类型:
            <el-select
              v-model="queryParam.returnVisit"
              size="mini"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              circle
              plain
              size="mini"
              @click="findTaskPage"
              icon="el-icon-search"
            ></el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row v-has="'task:select'">
      <el-col>
        <transition name="el-zoom-in-center">
          <el-table
            :data="tableData"
            style="width: 100%"
            :hide-on-single-page="singleShow"
            element-loading-text="正在加载数据"
            stripe
            border
            v-show="show"
          >
            <el-table-column label="任务类型" align="center" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.returnVisit">回访短信</span>
                <span v-else>常规短信</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="templateContent"
              label="短信内容"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            
            <el-table-column
              prop="cronDesc"
              label="时间配置"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              label="发送的用户"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.returnVisit"
                  >{{scope.row.sendTypeName}} - {{scope.row.sendChildTypeName}}客户</el-tag
                >
                <el-tag
                  v-else
                  v-for="item in scope.row.sendMembers"
                  :key="item.name"
                  :type="item.name"
                  effect="plain"
                >
                  {{ item.name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="120">
              <template slot-scope="scope">
                <div class="taskClose" v-if="scope.row.close">
                  <span>停止</span>
                </div>
                <div class="taskRun" v-else>
                  <i class="el-icon-loading"></i>
                  <span>运行中</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="任务创建时间"
              width="200"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.returnVisit && scope.row.close"
                  @click="switchTask(scope.row, 'start')"
                  >启动</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.returnVisit || !scope.row.close"
                  @click="switchTask(scope.row, 'close')"
                  >停止</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.close"
                  @click="switchTask(scope.row, 'delete')"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </transition>
        <el-row>
          <el-col :span="24">
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="paginations.page_index"
              :page-sizes="paginations.page_sizes"
              :page-size="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { findTaskPageList, switchTask } from "@/api/index";

export default {
  data() {
    return {
      show: false, //初始隐藏  为了打开的动画效果
      singleShow: false,
      queryParam: {
        returnVisit: null,
      },
      options: [
        { value: true, label: "回访短信" },
        { value: false, label: "常规短信" },
      ],
      tableData: [],
      paginations: {
        page_index: 1, //当前位于哪页
        total: 0, //总数
        page_size: 5, //每页显示多少条
        page_sizes: [5, 10, 20], //下拉选择
        layout: "total, sizes, prev, pager, next, jumper",
      },
    };
  },
  methods: {
    findTaskPage() {
      let that = this;
      findTaskPageList({
        returnVisit: this.queryParam.returnVisit,
        pageIndex: this.paginations.page_index,
        size: this.paginations.page_size,
      }).then((res) => {
        if (res.success == true) {
          that.tableData = res.result.list;
          this.paginations.total = res.result.total;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
    handleSizeChange(val) {
      this.paginations.page_size = val;
      this.findTaskPage();
    },
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.findTaskPage();
    },
    switchTask(row, data) {
      switchTask({
        operation: data,
        id: row.id,
      }).then((res) => {
        let operationStr = "启动成功"
        if (data == 'close') {
          operationStr = "停止成功"
        }
        if (data == 'delete') {
          operationStr = "删除成功"
        }
        if (res.success == true) {
          this.$message({
            showClose: true,
            message: operationStr,
            type: "success",
          });
          this.findTaskPage();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
  },
  created() {
    this.findTaskPage();
  },
  mounted() {
    this.show = true;
  },
};
</script>

<style lang="scss">
.taskManage {
  background-color: #ffffff;
  padding: 16px;
  margin: 20px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 3px 3px #c8c8c8;
  -moz-box-shadow: 0px 3px 3px #c8c8c8;
  box-shadow: 0px 3px 3px #c8c8c8;

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #ecf5ff;
  }
  .el-table__body tr.current-row > td {
    background: #0089ff !important;
    color: #ffffff;
  }
  .query {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 10px;
  }
  .el-table {
    .success-row {
      background: #f0f9eb;
    }
  }

  .taskClose {
    span {
      color: #f56c6c;
    }
  }
  .taskRun {
    i {
      font-size: 20px;
    }
    span {
      color: #409eff;
    }
  }
}
</style>